async function forgeRefreshCartCount() {
  try {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await res.json();

    document.querySelectorAll('.js-cart-count').forEach((el) => {
      el.textContent = cart.item_count;
    });
  } catch (e) {
    // fail silently
  }
}

// Update after any /cart/add request completes (covers apps + theme ajax)
(function hookFetch() {
  if (!window.fetch) return;
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
      if (url && url.includes('/cart/add')) {
        // let theme/cart drawer finish its own work first
        setTimeout(forgeRefreshCartCount, 150);
      }
    } catch (_) {}

    return response;
  };
})();

// Also catch classic form submits (some themes/apps still do this)
document.addEventListener('submit', (e) => {
  const form = e.target;
  if (form && form.matches('form[action*="/cart/add"]')) {
    setTimeout(forgeRefreshCartCount, 400);
  }
});

document.addEventListener('DOMContentLoaded', forgeRefreshCartCount);
